const PAYMENT_METHODS = ['sepa_debit', 'card'];

const AVAILABLE_PAYMENT_METHODS = ['sepa_debit', 'card', 'sofort'];

const STRIPE_KEY =
  'pk_test_51HXtPEB487DdbDtDsDlZhRZbPtgveEqSaVbTtwFTxS7G8dxnN36Q57J9RpPV6dI3vTMoz0QelnQXKoOTkursfYpS003BTJXQ0H';

export { PAYMENT_METHODS, STRIPE_KEY, AVAILABLE_PAYMENT_METHODS };
